<div [@depthX]="depthX(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<ngx-sonner-toaster position="bottom-right" richColors></ngx-sonner-toaster>
